import React from 'react';
import { Helmet } from 'react-helmet';

import Layout from '../components/Layout';
import Page from '../components/Page';

const PrivacyPolicy = () => {
	return (
		<Layout>
			<Page title="Privacy Policy">
				<Helmet>
					<meta name="robots" content="noindex" />
				</Helmet>

				<h1>Privacy Policy</h1>
				<h2>1. An overview of data protection</h2>
				<h3>General information</h3>
				<p>
					The following information will provide you with an easy to navigate
					overview of what will happen with your personal data when you visit
					this website. The term „personal data“ comprises all data that can be
					used to personally identify you. For detailed information about the
					subject matter of data protection, please consult our Data Protection
					Declaration, which we have included beneath this copy.
				</p>
				<h3>Data recording on this website</h3>
				<p>
					<strong>
						Who is the responsible party for the recording of data on this
						website (i.e. the „controller“)?
					</strong>
				</p>
				<p>
					The data on this website is processed by the operator of the website,
					whose contact information is available under section „Information
					Required by Law“ on this website.
				</p>
				<p>
					<strong>How do we record your data?</strong>
				</p>
				<p>
					We collect your data as a result of your sharing of your data with us.
					This may, for instance be information you enter into our contact form.
				</p>
				<p>
					Our IT systems automatically record other data when you visit our
					website. This data comprises primarily technical information (e.g. web
					browser, operating system or time the site was accessed). This
					information is recorded automatically when you access this website.
				</p>
				<p>
					<strong>What are the purposes we use your data for?</strong>
				</p>
				<p>
					A portion of the information is generated to guarantee the error free
					provision of the website. Other data may be used to analyse your user
					patterns.
				</p>
				<p>
					<strong>
						What rights do you have as far as your information is concerned?
					</strong>
				</p>
				<p>
					You have the right to receive information about the source, recipients
					and purposes of your archived personal data at any time without having
					to pay a fee for such disclosures. You also have the right to demand
					that your data are rectified or eradicated. Please do not hesitate to
					contact us at any time under the address disclosed in section
					„Information Required by Law“ on this website if you have questions
					about this or any other data protection related issues. You also have
					the right to log a complaint with the competent supervising agency.
				</p>
				<p>
					Moreover, under certain circumstances, you have the right to demand
					the restriction of the processing of your personal data. For details,
					please consult the Data Protection Declaration under section „Right to
					Restriction of Data Processing.“
				</p>
				<h3>Analysis tools and tools provided by third parties</h3>
				<p>
					There is a possibility that your browsing patterns will be
					statistically analysed when your visit this website. Such analyses are
					performed primarily with cookies and with what we refer to as analysis
					programmes. As a rule, the analyses of your browsing patterns are
					conducted anonymously; i.e. the browsing patterns cannot be traced
					back to you.
				</p>
				<p>
					You have the option to object to such analyses or you can prevent
					their performance by not using certain tools. For detailed information
					about the tools and about your options to object, please consult our
					Data Protection Declaration below.
				</p>
				<h2>2. Hosting</h2>
				<h3>External Hosting</h3>
				<p>
					This website is hosted by an external service provider (host).
					Personal data collected on this website are stored on the servers of
					the host. These may include, but are not limited to, IP addresses,
					contact requests, metadata and communications, contract information,
					contact information, names, web page access, and other data generated
					through a web site.
				</p>
				<p>
					The host is used for the purpose of fulfilling the contract with our
					potential and existing customers (Art. 6 para. 1 lit. b DSGVO) and in
					the interest of secure, fast and efficient provision of our online
					services by a professional provider (Art. 6 para. 1 lit. f DSGVO).
				</p>
				<p>
					Our host will only process your data to the extent necessary to fulfil
					its performance obligations and to follow our instructions with
					respect to such data.
				</p>
				<p>
					<strong>Execution of a contract data processing agreement</strong>
				</p>
				<p>
					In order to guarantee processing in compliance with data protection
					regulations, we have concluded an order processing contract with our
					host.
				</p>
				<h2>3. General information and mandatory information</h2>
				<h3>Data protection</h3>
				<p>
					The operators of this website and its pages take the protection of
					your personal data very seriously. Hence, we handle your personal data
					as confidential information and in compliance with the statutory data
					protection regulations and this Data Protection Declaration.
				</p>
				<p>
					Whenever you use this website, a variety of personal information will
					be collected. Personal data comprises data that can be used to
					personally identify you. This Data Protection Declaration explains
					which data we collect as well as the purposes we use this data for. It
					also explains how, and for which purpose the information is collected.
				</p>
				<p>
					We herewith advise you that the transmission of data via the Internet
					(i.e. through e-mail communications) may be prone to security gaps. It
					is not possible to completely protect data against third party access.
				</p>
				<h3>
					Information about the responsible party (referred to as the
					„controller“ in the GDPR)
				</h3>
				<p>The data processing controller on this website is:</p>
				<p>
					Simon Mayerhofer
					<br />
					zu Hd. Mayerhofer Holding GmbH
					<br />
					Espasinger Str. 7
					<br />
					78333 Stockach
				</p>
				<p>
					Phone: 015782459155
					<br />
					E-mail: privacy[-at-]maysi.de
				</p>
				<p>
					The controller is the natural person or legal entity that
					single-handedly or jointly with others makes decisions as to the
					purposes of and resources for the processing of personal data (e.g.
					names, e-mail addresses, etc.).
				</p>
				<h3>Revocation of your consent to the processing of data</h3>
				<p>
					A wide range of data processing transactions are possible only subject
					to your express consent. You can also revoke at any time any consent
					you have already given us. To do so, all you are required to do is
					sent us an informal notification via e-mail. This shall be without
					prejudice to the lawfulness of any data collection that occurred prior
					to your revocation.
				</p>
				<h3>
					Right to object to the collection of data in special cases; right to
					object to direct advertising (Art. 21 GDPR)
				</h3>
				<p>
					IN THE EVENT THAT DATA ARE PROCESSED ON THE BASIS OF ART. 6 SECT. 1
					LIT. E OR F GDPR, YOU HAVE THE RIGHT TO AT ANY TIME OBJECT TO THE
					PROCESSING OF YOUR PERSONAL DATA BASED ON GROUNDS ARISING FROM YOUR
					UNIQUE SITUATION. THIS ALSO APPLIES TO ANY PROFILING BASED ON THESE
					PROVISIONS. TO DETERMINE THE LEGAL BASIS, ON WHICH ANY PROCESSING OF
					DATA IS BASED, PLEASE CONSULT THIS DATA PROTECTION DECLARATION. IF YOU
					LOG AN OBJECTION, WE WILL NO LONGER PROCESS YOUR AFFECTED PERSONAL
					DATA, UNLESS WE ARE IN A POSITION TO PRESENT COMPELLING PROTECTION
					WORTHY GROUNDS FOR THE PROCESSING OF YOUR DATA, THAT OUTWEIGH YOUR
					INTERESTS, RIGHTS AND FREEDOMS OR IF THE PURPOSE OF THE PROCESSING IS
					THE CLAIMING, EXERCISING OR DEFENCE OF LEGAL ENTITLEMENTS (OBJECTION
					PURSUANT TO ART. 21 SECT. 1 GDPR).
				</p>
				<p>
					IF YOUR PERSONAL DATA IS BEING PROCESSED IN ORDER TO ENGAGE IN DIRECT
					ADVERTISING, YOU HAVE THE RIGHT TO AT ANY TIME OBJECT TO THE
					PROCESSING OF YOUR AFFECTED PERSONAL DATA FOR THE PURPOSES OF SUCH
					ADVERTISING. THIS ALSO APPLIES TO PROFILING TO THE EXTENT THAT IT IS
					AFFILIATED WITH SUCH DIRECT ADVERTISING. IF YOU OBJECT, YOUR PERSONAL
					DATA WILL SUBSEQUENTLY NO LONGER BE USED FOR DIRECT ADVERTISING
					PURPOSES (OBJECTION PURSUANT TO ART. 21 SECT. 2 GDPR).
				</p>
				<h3>Right to log a complaint with the competent supervisory agency</h3>
				<p>
					In the event of violations of the GDPR, data subjects are entitled to
					log a complaint with a supervisory agency, in particular in the member
					state where they usually maintain their domicile, place of work or at
					the place where the alleged violation occurred. The right to log a
					complaint is in effect regardless of any other administrative or court
					proceedings available as legal recourses.
				</p>
				<h3>Right to data portability</h3>
				<p>
					You have the right to demand that we hand over any data we
					automatically process on the basis of your consent or in order to
					fulfil a contract be handed over to you or a third party in a commonly
					used, machine readable format. If you should demand the direct
					transfer of the data to another controller, this will be done only if
					it is technically feasible.
				</p>
				<h3>SSL and/or TLS encryption</h3>
				<p>
					For security reasons and to protect the transmission of confidential
					content, such as purchase orders or inquiries you submit to us as the
					website operator, this website uses either an SSL or a TLS encryption
					programme. You can recognise an encrypted connection by checking
					whether the address line of the browser switches from „http://“ to
					„https://“ and also by the appearance of the lock icon in the browser
					line.
				</p>
				<p>
					If the SSL or TLS encryption is activated, data you transmit to us
					cannot be read by third parties.
				</p>
				<h3>Information about, rectification and eradication of data</h3>
				<p>
					Within the scope of the applicable statutory provisions, you have the
					right to at any time demand information about your archived personal
					data, their source and recipients as well as the purpose of the
					processing of your data. You may also have a right to have your data
					rectified or eradicated. If you have questions about this subject
					matter or any other questions about personal data, please do not
					hesitate to contact us at any time at the address provided in section
					„Information Required by Law.“
				</p>
				<h3>Right to demand processing restrictions</h3>
				<p>
					You have the right to demand the imposition of restrictions as far as
					the processing of your personal data is concerned. To do so, you may
					contact us at any time at the address provided in section „Information
					Required by Law.“ The right to demand restriction of processing
					applies in the following cases:
				</p>
				<ul>
					<li>
						In the event that you should dispute the correctness of your data
						archived by us, we will usually need some time to verify this claim.
						During the time that this investigation is ongoing, you have the
						right to demand that we restrict the processing of your personal
						data.
					</li>
					<li>
						If the processing of your personal data was/is conducted in an
						unlawful manner, you have the option to demand the restriction of
						the processing of your data in lieu of demanding the eradication of
						this data.
					</li>
					<li>
						If we do not need your personal data any longer and you need it to
						exercise, defend or claim legal entitlements, you have the right to
						demand the restriction of the processing of your personal data
						instead of its eradication.
					</li>
					<li>
						If you have raised an objection pursuant to Art. 21 Sect. 1 GDPR,
						your rights and our rights will have to be weighed against each
						other. As long as it has not been determined whose interests
						prevail, you have the right to demand a restriction of the
						processing of your personal data.
					</li>
				</ul>
				<p>
					If you have restricted the processing of your personal data, these
					data – with the exception of their archiving – may be processed only
					subject to your consent or to claim, exercise or defend legal
					entitlements or to protect the rights of other natural persons or
					legal entities or for important public interest reasons cited by the
					European Union or a member state of the EU.
				</p>
				<h3>Rejection of unsolicited e-mails</h3>
				<p>
					We herewith object to the use of contact information published in
					conjunction with the mandatory information to be provided in section
					„Information Required by Law“ to send us promotional and information
					material that we have not expressly requested. The operators of this
					website and its pages reserve the express right to take legal action
					in the event of the unsolicited sending of promotional information,
					for instance via SPAM messages.
				</p>
				<h2>4. Recording of data on this website</h2>
				<h3>Cookies</h3>
				<p>
					In some instances, our website and its pages use so-called cookies.
					Cookies do not cause any damage to your computer and do not contain
					viruses. The purpose of cookies is to make our website more user
					friendly, effective and more secure. Cookies are small text files that
					are placed on your computer and stored by your browser.
				</p>
				<p>
					Most of the cookies we use are so-called „session cookies.“ They are
					automatically deleted after your leave our site. Other cookies will
					remain archived on your device until you delete them. These cookies
					enable us to recognise your browser the next time you visit our
					website.
				</p>
				<p>
					You can adjust the settings of your browser to make sure that you are
					notified every time cookies are placed and to enable you to accept
					cookies only in specific cases or to exclude the acceptance of cookies
					for specific situations or in general and to activate the automatic
					deletion of cookies when you close your browser. If you deactivate
					cookies, the functions of this website may be limited.
				</p>
				<p>
					Cookies that are required for the performance of the electronic
					communications transaction or to provide certain functions you want to
					use (e.g. the shopping cart function), are stored on the basis of Art.
					6 Sect. 1 lit. f GDPR. The website operator has a legitimate interest
					in storing cookies to ensure the technically error free and optimised
					provision of the operator’s services. If a corresponding agreement has
					been requested (e.g. an agreement to the storage of cookies), the
					processing takes place exclusively on the basis of Art. 6 para. 1 lit.
					a GDPR; the agreement can be revoked at any time.
				</p>
				<p>
					If other cookies (e.g. cookies for the analysis of your browsing
					patterns) should be stored, they are addressed separately in this Data
					Protection Declaration.
				</p>
				<h3>Server log files</h3>
				<p>
					The provider of this website and its pages automatically collects and
					stores information in so-called server log files, which your browser
					communicates to us automatically. The information comprises:
				</p>
				<ul>
					<li>The type and version of browser used</li>
					<li>The used operating system</li> <li>Referrer URL</li>
					<li>The hostname of the accessing computer</li>
					<li>The time of the server inquiry</li> <li>The IP address</li>
				</ul>
				<p>This data is not merged with other data sources.</p>
				<p>
					This data is recorded on the basis of Art. 6 Sect. 1 lit. f GDPR. The
					operator of the website has a legitimate interest in the technically
					error free depiction and the optimization of the operator’s website.
					In order to achieve this, server log files must be recorded.
				</p>
				<h3>Contact form</h3>
				<p>
					If you submit inquiries to us via our contact form, the information
					provided in the contact form as well as any contact information
					provided therein will be stored by us in order to handle your inquiry
					and in the event that we have further questions. We will not share
					this information without your consent.
				</p>
				<p>
					The processing of these data is based on Art. 6 para. 1 lit. b GDPR,
					if your request is related to the execution of a contract or if it is
					necessary to carry out pre-contractual measures. In all other cases
					the processing is based on our legitimate interest in the effective
					processing of the requests addressed to us (Art. 6 Para. 1 lit. f
					DSGVO) or on your agreement (Art. 6 Para. 1 lit. a DSGVO) if this has
					been requested.
				</p>
				<p>
					The information you have entered into the contact form shall remain
					with us until you ask us to eradicate the data, revoke your consent to
					the archiving of data or if the purpose for which the information is
					being archived no longer exists (e.g. after we have concluded our
					response to your inquiry). This shall be without prejudice to any
					mandatory legal provisions – in particular retention periods.
				</p>
				<h3>Request by e-mail, telephone or fax</h3>
				<p>
					If you contact us by e-mail, telephone or fax, your request, including
					all resulting personal data (name, request) will be stored and
					processed by us for the purpose of processing your request. We do not
					pass these data on without your consent.
				</p>
				<p>
					The processing of these data is based on Art. 6 para. 1 lit. b GDPR,
					if your request is related to the execution of a contract or if it is
					necessary to carry out pre-contractual measures. In all other cases,
					the processing is based on your consent (Article 6 (1) a GDPR) and/or
					on our legitimate interests (Article 6 (1) (f) GDPR), since we have a
					legitimate interest in the effective processing of requests addressed
					to us.
				</p>
				<p>
					The data sent by you to us via contact requests remain with us until
					you request us to delete, revoke your consent to the storage or the
					purpose for the data storage lapses (e.g. after completion of your
					request). Mandatory statutory provisions - in particular statutory
					retention periods - remain unaffected.
				</p>
				<h2>5. Plug-ins and Tools</h2>
				<h3>Google Web Fonts (local embedding)</h3>
				<p>
					This website uses so-called Web Fonts provided by Google to ensure the
					uniform use of fonts on this site. These Google fonts are locally
					installed so that a connection to Google’s servers will not be
					established in conjunction with this application.
				</p>
			</Page>
		</Layout>
	);
};

export default PrivacyPolicy;
